import React, { useState } from 'react'
import { ColorPicker } from 'components/ColorPicker'
import type { ColorpickerColor } from 'components/ColorPicker'

const PALETTE: ColorpickerColor[] = [
  { background: '#FEE2E2', text: '#991B1B' },
  { background: '#FEF3C7', text: '#92400E' },
  { background: '#D1FAE5', text: '#065F46' },
  { background: '#DBEAFE', text: '#1E40AF' },
  { background: '#EDE9FE', text: '#5B21B6' },
  { background: '#FCE7F3', text: '#9D174D' },
]

export function ColorPickerMock(): React.ReactElement {
  const [color, setColor] = useState<ColorpickerColor | undefined>(PALETTE[3])
  return (
    <div className="w-full max-w-xs">
      <ColorPicker
        label="Tag color"
        colors={PALETTE}
        value={color}
        onChange={setColor}
        optional
      />
    </div>
  )
}
